import { Box } from '@mui/material';
import { styled } from '@mui/system';

export const ProfileStyles = styled(Box)(({ theme }) => ({
    '& .container': {
        maxWidth:"max-content",
        justifySelf: 'center',
        paddingLeft: theme.spacing(0),
        paddingRight: theme.spacing(0),
        marginBottom: theme.spacing(5),
        marginLeft: theme.spacing(0),
        marginRight: theme.spacing(0),
        height: theme.pageHeight-100,
        marginTop: theme.spacing(6),
        overflow: 'auto', // Ensures children do not go beyond the container height

    },
    '& .paper': {
        paddingTop: theme.spacing(0),
        borderRadius: '15px !important',
    },
    '& .profileSection': {
        borderRight: `1px solid ${theme.palette.divider}`,
        [theme.breakpoints.down('md')]: {
            borderRight: 'none',
            borderBottom: `1px solid ${theme.palette.divider}`,
        },
        paddingRight: theme.spacing(0),
        paddingLeft: "24px !important",
    },
    '& .profileContent': {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        padding: theme.spacing(0),
    },
    '& .avatar': {
        width: theme.spacing(20),
        height: theme.spacing(20),
        marginBottom: theme.spacing(1),
    },
    '& .profileName': {
        fontWeight: 'bold',
        marginBottom: theme.spacing(1),
        wordBreak: 'break-word',    // Allows breaking long words
        whiteSpace: 'normal',       // Ensures wrapping happens
        overflowWrap: 'break-word', // Ensures breaking at spaces
        textAlign: 'center',        // Centers the text
        display: 'block',            // Ensures correct behavior in Typography
        paddingLeft: theme.spacing(1),
        paddingRight: theme.spacing(1),
    },
    '& .formSection': {
        borderRight: `1px solid ${theme.palette.divider}`,
        [theme.breakpoints.down('md')]: {
            borderRight: 'none',
            borderBottom: `1px solid ${theme.palette.divider}`,
        },
        paddingRight: theme.spacing(3),
        paddingLeft: theme.spacing(3),
    },
    '& .sectionTitle': {
        marginBottom: theme.spacing(3),
    },
    '& .saveButton': {
        marginTop: theme.spacing(3),
        padding: theme.spacing(1.5),
        fontSize: '1rem',
        fontWeight: 'bold',
        '&:hover': {
            backgroundColor: 'white',
            color: theme.palette.primary.main,
            border: `1px solid ${theme.palette.primary.main}`,
        },
    },
    '& .roleSection': {
        paddingLeft: theme.spacing(2),
        paddingRight: theme.spacing(2),
        [theme.breakpoints.down('md')]: {
            paddingLeft: 0,
        },
    },
    '& .roleHeader': {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: theme.spacing(3),
    },
    '& .textField': {
        marginTop: theme.spacing(0.8),
        marginBottom: theme.spacing(0.8),
    },
    '& .roleSubHeader': {
        marginTop: theme.spacing(2),
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: theme.spacing(2),
        fontWeight: 'bold',
    },
    '& .passwordSectionHeader': {

        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: theme.spacing(1),


    },
    '& .passwordSection': {
        borderTop: `1px solid ${theme.palette.divider}`,
        marginTop: theme.spacing(4),

    },
}));
